import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../API/EndPoints";
import AxiosInstance from "../API/AxiosInstance";

export const getBilling = createAsyncThunk(
  "master/getBilling",
  async (credentials) => {
    const response = await AxiosInstance.get(API_ENDPOINTS.BILLING, {
      params: credentials,
    });
    return response.data;
  }
);

const billingSlice = createSlice({
  name: "getBilling",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBilling.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBilling.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(getBilling.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default billingSlice.reducer;
